import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../buttons/button/button.component';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    imports: [CommonModule, ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogConfirmComponent {

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<DialogConfirmComponent>
	) { }

	accept() {
		this.dialogRef.close(true);
	}

	cancel() {
		this.dialogRef.close(false);
	}
}
